import { select } from '@ngrx/store';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		HostListener,
		Input
	}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { KhachHangService } from '../../../danh-muc/khach-hang/khach-hang-service/khach-hang.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { CommonConFig, NhaCungCapModelLite } from '../../../dung-chung/__model/common_config.model';
import { SelectionModel } from '@angular/cdk/collections';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import moment from 'moment';
import { DonHangMuaDataSource } from '../don-hang-mua-page-datasource/don-hang-mua.datasource';
import { DonHangMuaService } from '../don-hang-mua-page-service/don-hang-mua.service';
import { LichSuGiaoHang } from '../don-hang-mua-page-model/don-hang-mua.model';
import { environment } from '../../../../../../../environments/environment';

@Component({
	selector: 'kt-lich-su-giao-hang',
	templateUrl: './lich-su-giao-hang.component.html',
	styleUrls: ['../don-hang-mua-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class LichSuGiaoHangComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	dataSource: DonHangMuaDataSource;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	viewLoading = false;
	/* ------------------------------------------------------------------ */

	//#region Phím tắt
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode){
			this.back();
		}
	}
	//#endregion Phím tắt

	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true,
			type: 'number'
        },
        {
            stt: 2,
            name: 'SLNhapKho',
            displayName: 'SL nhập kho',
            alwaysChecked: false,
			isShow: true,
			type: 'number'
		},
		{
            stt: 2,
            name: 'SLHangVe',
            displayName: 'SL hàng về',
            alwaysChecked: false,
			isShow: true,
			type: 'number'
        },
        {
            stt: 3,
            name: 'DVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true,
			type: 'string'
		},
		{
            stt: 4,
            name: 'NgayGioVaoCong',
            displayName: 'Ngày giờ vào cổng',
            alwaysChecked: false,
			isShow: true,
			type: 'datetime'
        },
        {
            stt: 5,
            name: 'SoPhieuTTHV',
            displayName: 'Số phiếu TTHV',
            alwaysChecked: false,
			isShow: true,
			type: 'string'
		},
		{
            stt: 5,
            name: 'NgayLapPhieuTTHV',
            displayName: 'Ngày lập phiếu TTHV',
            alwaysChecked: false,
			isShow: true,
			type: 'date'
		}
	];
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;

	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	preFilterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	
	@Input() title: string = "LỊCH SỬ GIAO HÀNG CỦA";
	@Input() subTitle: string = "";

	DonHangMuaResult = [];
	tmpDonHangMuaResult = [];

	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<any>(true, []);

	IdHH: number = 0;
	IdCtDHB: number = 0;

	constructor(
		public 	dialogRef2: MatDialogRef<LichSuGiaoHangComponent>,
		public 	dialog2: MatDialog,
		private changeDetect: ChangeDetectorRef,
		private service : DonHangMuaService,
		private layoutUtilsService: LayoutUtilsService,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {}

	//#region Load Data
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;

		this.subTitle = this.data.Ma_Ten_HH;
		this.IdHH = this.data.IdHH;
		this.IdCtDHB = this.data.IdCtDHB;

		this.dataSource = new DonHangMuaDataSource(this.service);
		
		this.dataSource.entitySubject.subscribe(res => {
			this.DonHangMuaResult = res
			this.tmpDonHangMuaResult = []
			if(this.DonHangMuaResult != null){
				for(let i = 0; i < this.DonHangMuaResult.length; i++){
					let tmpElement = new LichSuGiaoHang();
					tmpElement.clear();
					tmpElement.copy(this.DonHangMuaResult[i])
					this.tmpDonHangMuaResult.push(tmpElement);
				}
			}
		});
		this.loadLichSuGiaoHangList();
		this.applySelectedColumns();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
		this.changeDetect.detectChanges();
	}

	loadLichSuGiaoHangList(highlight: boolean = false) {
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadLichSuGiaoHang(queryParams);
	}

	filterConfiguration(): any {
		const filter: any = {};
		filter.IdHH = this.IdHH ? this.IdHH : 0;
		filter.IdCtDHB = this.IdCtDHB ? this.IdCtDHB : 0;
		return filter;
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	//#endregion Load Data

	//#region Quay về
	back(){
		this.dialogRef2.close({});
	}
	//#endregion Quay về

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}

	fomartData(data : any, type: string){
		switch(type){
			case 'number': return this.f_number(data);
			case 'string': return data;
			case 'date' : return moment(data).format("DD/MM/YYYY");
			case 'datetime' : return moment(data).format("DD/MM/YYYY HH:mm");
			default: return data;
		}
	}
}

